namespace AgerLMS.LMS {
    export interface BundleForm {
        BundleName: Serenity.StringEditor;
        BundleType: Serenity.EnumEditor;
        CategoryId: Serenity.LookupEditor;
        Price: Serenity.DecimalEditor;
        SalePrice: Serenity.DecimalEditor;
        DemoVideoSource: Serenity.EnumEditor;
        AccessPeriodDays: Serenity.IntegerEditor;
        DemoVideo: Serenity.StringEditor;
        Downloadable: Serenity.BooleanEditor;
        Thumbnail: Serenity.ImageUploadEditor;
        CoverImage: Serenity.ImageUploadEditor;
        BundleDescription: Serenity.HtmlContentEditor;
    }

    export class BundleForm extends Serenity.PrefixedContext {
        static formKey = 'LMS.Bundle';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BundleForm.init)  {
                BundleForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.LookupEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.BooleanEditor;
                var w6 = s.ImageUploadEditor;
                var w7 = s.HtmlContentEditor;

                Q.initFormType(BundleForm, [
                    'BundleName', w0,
                    'BundleType', w1,
                    'CategoryId', w2,
                    'Price', w3,
                    'SalePrice', w3,
                    'DemoVideoSource', w1,
                    'AccessPeriodDays', w4,
                    'DemoVideo', w0,
                    'Downloadable', w5,
                    'Thumbnail', w6,
                    'CoverImage', w6,
                    'BundleDescription', w7
                ]);
            }
        }
    }
}
